<style scoped>
.justify {
  text-align: justify;
}
hr.divider {
  border: 1px solid #f2f2f2;
  background: transparent;
  margin: 10px 50px;
}
</style>

<template>
  <app-layout class="feed-single-page-template">
    <Row type="flex" justify="center">
      <Col :span="24">
        <div style="padding:20px">
          <Card border>
            <img alt=" " src="@/assets/about-bg.jpg" width="100%" />
            <div style="margin-top:10px;text-align:center">
              <p><b>Tapang at Masakit Alliance for the Philippines</b> is an umbrella organization of groups that support the Duterte administration.</p>

              <br/><p>Alliance Building</p>
              <hr class="divider">
              <p>To establish a broader and a more responsive alliance that can effectively mobilize support for government initiatives and positive change.</p>

              <br/><p>Responding to the Issues/Needs of the Members of the Alliance</h3>
              <hr class="divider">
              <p>To raise the needs and issues of the members of the alliance to the concerned agencies.</p>

              <br/><p>Marawi Rehabilitation</p>
              <hr class="divider">
              <p>To help build livable and sustainable communities as a result of effective private and public collaboration</p>
            </div>
          </Card>
        </div>
      </Col>
    </Row>
    <contact-us-component></contact-us-component>
  </app-layout>
</template>

<script>
import ContactUsComponent from '@/views/ContactUsComponent'
export default {
  name: 'AboutUsComponent',
  components: {
    ContactUsComponent
  }
}
</script>
